<div class="numpadWrapper {{ SimStatusPalette.success }}">
	<div class="digitGrid">
		@for (control of controls; track control) {
			@if (control > -1 && control !== null) {
				<button mat-ripple class="digit" (click)="onDigitClick(control)">
					{{ control }}
				</button>
			} @else if (control === -1) {
				<button mat-ripple class="backspace" (click)="onBackspaceClick()">
					<mat-icon fontSet="fas" fontIcon="fa-backspace" />
				</button>
			}
		}
	</div>
</div>
